import { HTMLAttributes } from 'react'

import FluidSpacer from '@/components/base/fluid-spacer'
import { MediaElement } from '@/components/base/media'
import HeroCover from '@/components/sections/hero-cover'
import ImageText from '@/components/sections/image-text'
import Spacer from '@/components/sections/spacer'
import { type Slide } from '@/contexts/carousel'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type HeroCategoryProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    bgcolor: string
    use_carousel: boolean
    breadcrumbs: WPLink[]
    slides: Slide[]
    image_text: {
      theme: 'dark' | 'light'
      title: string
      paragraph: string
      media: MediaElement
      alignment: 'left' | 'right'
      overwrite_text_color: boolean
      text_color: string
    }
  }>

const HeroCategory = ({
  bgcolor,
  use_carousel,
  breadcrumbs,
  slides = [],
  image_text,
  ...props
}: HeroCategoryProps) => {
  return (
    <div {...props}>
      <HeroCover
        breadcrumbs={breadcrumbs}
        use_carousel={use_carousel}
        slides={slides}
        style={{ backgroundColor: bgcolor }}
      />
      <Spacer variant="lg" style={{ backgroundColor: bgcolor }} />
      <div className={cn([{ dark: image_text?.theme === 'dark' }])}>
        <ImageText
          double_paragraph={false}
          media={image_text?.media}
          title={image_text?.title}
          paragraph_1={image_text?.paragraph}
          alignment={image_text?.alignment}
          style={{
            backgroundColor: bgcolor
          }}
          text_color={
            image_text?.overwrite_text_color
              ? image_text?.text_color
              : undefined
          }
        />
      </div>
      <Spacer variant="lg" style={{ backgroundColor: bgcolor }} />
      <FluidSpacer variant="bottom" backgroundColor={bgcolor} />
    </div>
  )
}

export default HeroCategory
